(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      dec = dec == null ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return whole + (parts[1] ? ds + parts[1] : '');
    }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  var COLOR_MAP = [
    ['grey', '#AEB4C0'], ['gray', '#AEB4C0'], ['silver', '#C9CCD3'], ['navy', '#1F2C4E'], ['blue', '#3D6BD9'],
    ['black', '#121318'], ['jet', '#121318'], ['white', '#F4F4F4'], ['cream', '#F1E8D6'], ['beige', '#D9C7A7'],
    ['pink', '#E7A6C7'], ['rose', '#E7A6C7'], ['red', '#D64545'], ['green', '#4E8F5A'], ['olive', '#6B7A3A'],
    ['purple', '#7A5CF0'], ['lilac', '#B9A6F2'], ['brown', '#7A5236'], ['orange', '#F08A3C'], ['yellow', '#F5C51C']
  ];
  function guessColor(name) {
    var s = (name || '').toLowerCase();
    for (var i = 0; i < COLOR_MAP.length; i++) if (s.indexOf(COLOR_MAP[i][0]) > -1) return COLOR_MAP[i][1];
    return '';
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function init(root) {
    if (!root || root.dataset.lpReady) return;
    root.dataset.lpReady = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-lp-variants]').textContent); } catch (e) {}
    var opts = variants.filter(function (v) { return v.opt; });
    var firstAvail = (opts.filter(function (v) { return v.available; })[0] || opts[0] || variants[0] || {});
    var state = { bundle: 1, styles: [] };
    var initialBundle = root.querySelector('.lp-buy__bundle.is-selected');
    if (initialBundle) state.bundle = +initialBundle.dataset.lpBundle;
    for (var k = 0; k < 6; k++) state.styles[k] = firstAvail.opt;

    var moneyFormat = root.dataset.moneyFormat;
    var labelOne = root.dataset.styleLabel || 'Color';
    var labelMulti = root.dataset.styleLabelMulti || 'Color · item [n]';
    var saveWord = root.dataset.saveWord || 'SAVE';
    var anyColor = opts.some(function (o) { return o.color || guessColor(o.opt); });

    function variantFor(opt) {
      var m = variants.filter(function (v) { return v.opt === opt; })[0];
      return m || variants[0];
    }

    /* ---------- color / variant pickers per bundle ---------- */
    function renderStyles() {
      root.querySelectorAll('[data-lp-styles]').forEach(function (box) {
        var b = +box.dataset.lpStyles;
        if (b !== state.bundle || opts.length < 2 || root.dataset.showStyles === 'false') { box.innerHTML = ''; return; }
        var html = '';
        for (var r = 0; r < b; r++) {
          html += '<span class="lp-buy__stylelabel">' + esc(b > 1 ? labelMulti.replace('[n]', r + 1) : labelOne) + '</span><div class="lp-buy__swatches">';
          opts.forEach(function (o) {
            var col = o.color || guessColor(o.opt);
            var active = state.styles[r] === o.opt ? ' is-active' : '';
            var dis = o.available ? '' : ' disabled style="opacity:.35;cursor:not-allowed' + (col && anyColor ? ';background:' + col : '') + '"';
            if (col && anyColor) {
              html += '<button type="button" class="lp-buy__sw' + active + '"' + (dis || ' style="background:' + col + '"') + ' title="' + esc(o.opt) + '" aria-label="' + esc(o.opt) + '" data-r="' + r + '" data-o="' + esc(o.opt) + '"></button>';
            } else {
              html += '<button type="button" class="lp-buy__sw lp-buy__sw--text' + active + '"' + dis + ' data-r="' + r + '" data-o="' + esc(o.opt) + '">' + esc(o.opt) + '</button>';
            }
          });
          html += '</div>';
        }
        box.innerHTML = html;
        box.querySelectorAll('.lp-buy__sw').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            state.styles[+btn.dataset.r] = btn.dataset.o;
            renderStyles();
            showVariant(btn.dataset.o);
          });
        });
      });
    }

    /* ---------- bundles ---------- */
    root.querySelectorAll('[data-lp-bundle]').forEach(function (card) {
      card.querySelector('[data-lp-bundle-pick]').addEventListener('click', function () {
        state.bundle = +card.dataset.lpBundle;
        root.querySelectorAll('[data-lp-bundle]').forEach(function (c) {
          var sel = c === card;
          c.classList.toggle('is-selected', sel);
          var inner = c.querySelector('.lp-buy__inner');
          if (inner) inner.hidden = !sel;
        });
        var pe = root.querySelector('[data-lp-price]'), ce = root.querySelector('[data-lp-compare]'), se = root.querySelector('[data-lp-save]');
        if (pe) pe.textContent = card.dataset.price;
        if (ce) ce.textContent = card.dataset.compare || '';
        if (se) {
          var sv = +card.dataset.save;
          se.hidden = !sv;
          se.textContent = saveWord + ' ' + sv + '%';
        }
        renderStyles();
      });
    });
    renderStyles();

           var preBundle = root.querySelector('[data-lp-bundle] .lp-buy__popular');
       if (preBundle) { var pb = preBundle.closest('[data-lp-bundle]').querySelector('[data-lp-bundle-pick]'); if (pb) pb.click(); }
    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-lp-track]');
    var thumbs = root.querySelectorAll('[data-lp-thumb]');
    var slideCount = root.querySelectorAll('.lp-buy__slide').length;
    var realCount = slideCount - 1;
    var tt = root.querySelector('[data-lp-thumbtrack]');
    function goTo(i, smooth) { if (track) track.scrollTo({ left: track.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' }); }
    function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
    function showVariant(opt) {
      var v = variantFor(opt);
      if (v && v.slide > -1) goTo(v.slide);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.lpThumb); }); });
    var scrollTimer = null;
    if (track) {
      track.addEventListener('scroll', function () {
        var i = cur(), vis = i >= realCount ? 0 : i;
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === vis); });
        if (thumbs[vis] && tt) {
          var tl = thumbs[vis].offsetLeft - tt.offsetLeft;
          if (tl < tt.scrollLeft || tl + thumbs[vis].offsetWidth > tt.scrollLeft + tt.clientWidth) tt.scrollTo({ left: tl, behavior: 'smooth' });
        }
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { if (cur() >= realCount) goTo(0, false); }, 140);
      }, { passive: true });
    }
    var tprev = root.querySelector('[data-lp-tprev]'), tnext = root.querySelector('[data-lp-tnext]');
    if (tnext) tnext.addEventListener('click', function () { tt.scrollBy({ left: tt.clientWidth, behavior: 'smooth' }); });
    if (tprev) tprev.addEventListener('click', function () { tt.scrollBy({ left: -tt.clientWidth, behavior: 'smooth' }); });
    var prev = root.querySelector('[data-lp-prev]'), next = root.querySelector('[data-lp-next]');
    if (next) next.addEventListener('click', function () {
      var i = cur();
      if (i >= realCount - 1) { goTo(realCount); setTimeout(function () { goTo(0, false); }, 420); } else goTo(i + 1);
    });
    if (prev) prev.addEventListener('click', function () {
      var i = cur();
      if (i <= 0) { goTo(realCount, false); goTo(realCount - 1); } else goTo(i - 1);
    });


    /* ---------- pick-your-pieces mode ---------- */
    var pick = root.dataset.mode === 'picker' ? root.querySelector('[data-lp-pick]') : null;
    function updatePick() {
      if (!pick) return;
      var total = 0, cmpTotal = 0, count = 0;
      pick.querySelectorAll('[data-lp-row]').forEach(function (row) {
        var q = +row.querySelector('[data-lp-q]').textContent || 0;
        var pr = +row.dataset.price || 0, cp = +row.dataset.compare || 0;
        total += pr * q; cmpTotal += Math.max(cp, pr) * q; count += q;
        row.classList.toggle('is-on', q > 0);
      });
      var t = pick.querySelector('[data-lp-total]'); if (t) t.textContent = formatMoney(total, moneyFormat);
      var c = pick.querySelector('[data-lp-count]'); if (c) c.textContent = count + ' ' + (count === 1 ? (root.dataset.itemWord || 'item') : (root.dataset.itemsWord || 'items'));
      var pe = root.querySelector('[data-lp-price]'), ce = root.querySelector('[data-lp-compare]'), se = root.querySelector('[data-lp-save]');
      if (pe) pe.textContent = formatMoney(total, moneyFormat);
      var sv = cmpTotal > total && total > 0 ? Math.floor((cmpTotal - total) * 100 / cmpTotal) : 0;
      if (ce) ce.textContent = sv ? formatMoney(cmpTotal, moneyFormat) : '';
      if (se) { se.hidden = !sv; se.textContent = saveWord + ' ' + sv + '%'; }
      var b = root.querySelector('[data-lp-atc]');
      if (b && !b.dataset.busy) {
        b.disabled = count === 0;
        b.textContent = count === 0 ? (root.dataset.atcEmpty || 'Choose at least one piece') : (b.dataset.label || 'Add to cart');
      }
    }
    if (pick) {
      pick.querySelectorAll('[data-lp-row]').forEach(function (row) {
        var qe = row.querySelector('[data-lp-q]');
        function set(n) { qe.textContent = Math.max(0, Math.min(99, n)); updatePick(); }
        var mi = row.querySelector('[data-lp-minus]'), pl = row.querySelector('[data-lp-plus]');
        if (mi) mi.addEventListener('click', function () { set((+qe.textContent || 0) - 1); });
        if (pl) pl.addEventListener('click', function () { set((+qe.textContent || 0) + 1); });
        var sh = row.querySelector('[data-lp-show]');
        if (sh) sh.addEventListener('click', function () { var sl = +row.dataset.slide; if (sl > -1) goTo(sl); });
      });
      var tg = pick.querySelector('[data-lp-toggle]'), sg = pick.querySelector('[data-lp-singles]');
      if (tg && sg) {
        var setOpen = function (open) {
          sg.hidden = !open; tg.setAttribute('aria-expanded', open ? 'true' : 'false'); tg.classList.toggle('is-open', open);
          var l = tg.querySelector('[data-lp-toggle-label]'); if (l) l.textContent = open ? tg.dataset.open : tg.dataset.closed;
        };
        var anyOn = Array.prototype.some.call(sg.querySelectorAll('[data-lp-q]'), function (q) { return +q.textContent > 0; });
        setOpen(anyOn);
        tg.addEventListener('click', function () { setOpen(sg.hidden); });
      }
      updatePick();
    }

    /* ---------- sticky add-to-cart bar (mobile) ---------- */
    var sticky = root.querySelector('[data-lp-sticky]');
    var mainAtc = root.querySelector('[data-lp-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var stPrice = sticky.querySelector('[data-lp-sticky-price]');
      var topPrice = root.querySelector('[data-lp-price]');
      var syncSticky = function () { if (stPrice && topPrice) stPrice.textContent = topPrice.textContent; };
      var mq = window.matchMedia('(max-width: 749px)');
      var past = false;
      var show = function () { syncSticky(); sticky.hidden = !(past && mq.matches); };
      new IntersectionObserver(function (en) {
        past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; show();
      }).observe(mainAtc);
      if (mq.addEventListener) mq.addEventListener('change', show);
      if (topPrice && 'MutationObserver' in window) new MutationObserver(syncSticky).observe(topPrice, { childList: true, characterData: true, subtree: true });
      sticky.querySelector('[data-lp-sticky-btn]').addEventListener('click', function () {
        if (mainAtc.disabled) { mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        mainAtc.click();
      });
    }

    /* ---------- delivery timeline ---------- */
    var day = 864e5, now = new Date();
    function fd(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
    var shipD = +root.dataset.shipMin || 0, dMin = +root.dataset.delMin || 0, dMax = +root.dataset.delMax || 0;
    var d0 = root.querySelector('[data-lp-d0]'), d1 = root.querySelector('[data-lp-d1]'), d2 = root.querySelector('[data-lp-d2]');
    if (d0) d0.textContent = fd(now);
    if (d1) d1.textContent = fd(new Date(+now + shipD * day));
    if (d2) d2.textContent = fd(new Date(+now + dMin * day)) + (dMax > dMin ? ' – ' + fd(new Date(+now + dMax * day)) : '');

    /* ---------- cart (global slide-out cart: assets/lp-cart.js) ---------- */
    function root_url(p) { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + p; }
    function addItems(items) {
      if (window.LPCart) return window.LPCart.add(items);
      return fetch(root_url('cart/add.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }
    function openCart() {
      if (window.LPCart) window.LPCart.open();
      else window.location.href = root_url('cart');
    }

    var atc = root.querySelector('[data-lp-atc]');
    if (atc) atc.addEventListener('click', function () {
      var btn = this, label = btn.dataset.label || 'Add to cart';
      btn.textContent = 'Adding…'; btn.disabled = true;
      var items = [], counts = {};
      if (pick) {
        pick.querySelectorAll('[data-lp-row]').forEach(function (row) {
          var q = +row.querySelector('[data-lp-q]').textContent || 0;
          if (q > 0 && +row.dataset.id) items.push({ id: +row.dataset.id, quantity: q });
        });
        pick.querySelectorAll('[data-lp-addon]').forEach(function (cb) { if (cb.checked) items.push({ id: +cb.dataset.lpAddon, quantity: 1 }); });
        if (!items.length) { btn.textContent = label; btn.disabled = false; updatePick(); return; }
        btn.dataset.busy = '1';
        addItems(items)
          .then(function () { delete btn.dataset.busy; btn.textContent = label; btn.disabled = false; updatePick(); openCart(); })
          .catch(function (err) {
            delete btn.dataset.busy; btn.textContent = label; btn.disabled = false; updatePick();
            window.alert((err && (err.description || err.message)) || 'Could not add to cart.');
          });
        return;
      }
      for (var u = 0; u < state.bundle; u++) {
        var v = opts.length ? variantFor(state.styles[u]) : variants[0];
        counts[v.id] = (counts[v.id] || 0) + 1;
      }
      Object.keys(counts).forEach(function (id) { items.push({ id: +id, quantity: counts[id] }); });
      var sel = root.querySelector('.lp-buy__bundle.is-selected');
      if (sel) sel.querySelectorAll('[data-lp-addon]').forEach(function (cb) { if (cb.checked) items.push({ id: +cb.dataset.lpAddon, quantity: 1 }); });
      var code = sel && sel.dataset.code;
      addItems(items)
        .then(function () { return code ? fetch(root_url('discount/' + encodeURIComponent(code)), { credentials: 'same-origin' }) : null; })
        .then(function () { btn.textContent = label; btn.disabled = false; openCart(); })
        .catch(function (err) {
          btn.textContent = label; btn.disabled = false;
          window.alert((err && (err.description || err.message)) || 'Could not add to cart.');
        });
    });
  }

  function boot() { document.querySelectorAll('[data-lp-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
